import React, { useEffect, useState } from 'react';
import { CONTRACT_TYPE_LABEL, downloadContractFile, myContracts, STATUS_COLOR, type Contract } from '../../../api/contractsApi';
import { fmtMoney } from '../../../api/billingApi';

/** The organisation's contracts and their key dates (SRS #85). Hidden when there are none. */
const ContractsCard: React.FC = () => {
  const [rows, setRows] = useState<Contract[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => { myContracts().then((r) => setRows(r.contracts)).catch(() => setRows([])); }, []);
  if (!rows || rows.length === 0) return null;

  const border = 'var(--ds-border, var(--ds-border))';
  const muted = 'var(--color-text-muted, var(--ds-text-muted))';
  const text = 'var(--color-text, var(--ds-text))';
  const fmt = (d: string | null) => (d ? new Date(d).toLocaleDateString() : '—');

  return (
    <section style={{ border: `1px solid ${border}`, borderRadius: 14, padding: 18, background: 'var(--ds-surface, #fff)', marginTop: 18 }}>
      <div style={{ fontSize: 16, fontWeight: 800, color: text }}>Contracts</div>
      <div style={{ fontSize: 12.5, color: muted, marginBottom: 12 }}>Agreements on file for your organisation, with the dates that matter.</div>
      {error && <div style={{ color: 'var(--ds-danger-text)', fontSize: 13 }}>{error}</div>}
      <div style={{ display: 'grid', gap: 10 }}>
        {rows.map((c) => {
          const col = STATUS_COLOR[c.status];
          const soon = c.days_to_notice_deadline != null && c.days_to_notice_deadline >= 0 && c.days_to_notice_deadline <= 60;
          return (
            <div key={c.id} style={{ border: `1px solid ${border}`, borderRadius: 10, padding: '10px 12px', display: 'grid', gridTemplateColumns: '1fr auto', gap: 8 }}>
              <div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                  <span style={{ fontFamily: 'ui-monospace, monospace', fontSize: 12, color: muted }}>{c.reference}</span>
                  <strong style={{ color: text, fontSize: 14 }}>{c.title}</strong>
                  <span style={{ padding: '1px 8px', borderRadius: 999, fontSize: 11, fontWeight: 600, background: col.bg, color: col.fg }}>{c.status}</span>
                  <span style={{ fontSize: 11.5, color: muted }}>{CONTRACT_TYPE_LABEL[c.contract_type]}</span>
                </div>
                <div style={{ fontSize: 12.5, color: muted, marginTop: 4 }}>
                  {fmt(c.start_date)} → {fmt(c.end_date)}
                  {c.auto_renew ? ` · auto-renews${c.renewal_term_months ? ` for ${c.renewal_term_months} months` : ''}` : ' · fixed term'}
                  {c.notice_deadline && <span style={{ color: soon ? 'var(--ds-warning)' : muted, fontWeight: soon ? 700 : 400 }}> · notice by {fmt(c.notice_deadline)}{c.days_to_notice_deadline != null && c.days_to_notice_deadline >= 0 ? ` (${c.days_to_notice_deadline} days)` : ''}</span>}
                  {c.value && ` · ${fmtMoney(c.value, c.currency)}`}
                  {c.seats && ` · ${c.seats} seats`}
                </div>
              </div>
              <div style={{ alignSelf: 'center' }}>
                {c.file
                  ? <button type="button" onClick={() => downloadContractFile(c.id).catch((e) => setError(e.message))} style={{ padding: '5px 10px', borderRadius: 6, border: `1px solid ${border}`, background: 'transparent', cursor: 'pointer', fontSize: 12.5, color: text }}>Download</button>
                  : <span style={{ fontSize: 11.5, color: muted }}>no document</span>}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ContractsCard;
